import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex min-w-0 items-center gap-2"
};
const _hoisted_2 = {
  key: 1,
  class: "w-4 shrink-0"
};
const _hoisted_3 = {
  key: 2,
  class: "shrink-0 rounded bg-red-100 px-1.5 py-0.5 text-[10px] text-red-600"
};
const _hoisted_4 = {
  key: 0,
  class: "flex shrink-0 items-center gap-1 opacity-0 transition-opacity group-hover:opacity-100"
};
import { computed } from 'vue';
export default {
  __name: 'KbCategoryTreeNode',
  props: {
    node: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    expandedIds: {
      type: Set,
      default: () => new Set()
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  emits: ['select', 'toggle', 'edit', 'delete', 'add-child'],
  setup(__props) {
    const props = __props;
    const hasChildren = computed(() => props.node.children?.length > 0);
    const isExpanded = computed(() => props.expandedIds.has(props.node.id));
    const isSelected = computed(() => props.selectedId !== null && Number(props.selectedId) === props.node.id);
    return (_ctx, _cache) => {
      const _component_KbCategoryTreeNode = _resolveComponent("KbCategoryTreeNode", true);
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = $event => hasChildren.value ? _ctx.$emit('toggle', __props.node.id) : _ctx.$emit('select', __props.node.id)),
        class: _normalizeClass(['group flex cursor-pointer items-center justify-between rounded-lg px-3 py-2 transition', isSelected.value ? 'bg-primary-50 font-medium text-primary-700' : 'text-slate-600 hover:bg-slate-50']),
        style: _normalizeStyle({
          paddingLeft: `${__props.depth * 16 + 12}px`
        })
      }, [_createElementVNode("div", _hoisted_1, [hasChildren.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('toggle', __props.node.id), ["stop"])),
        class: "flex h-4 w-4 shrink-0 items-center justify-center text-slate-400"
      }, [(_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(['h-3 w-3 transition-transform', isExpanded.value ? 'rotate-90' : '']),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      }, null, -1)]))], 2))])) : (_openBlock(), _createElementBlock("div", _hoisted_2)), _cache[12] || (_cache[12] = _createElementVNode("svg", {
        class: "h-4 w-4 shrink-0 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
      })], -1)), _createElementVNode("span", {
        class: "truncate text-sm",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.$emit('select', __props.node.id), ["stop"]))
      }, _toDisplayString(__props.node.name), 1), __props.node.status === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "停用")) : _createCommentVNode("", true)]), __props.showActions ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.$emit('add-child', __props.node), ["stop"])),
        class: "rounded p-1 text-slate-400 hover:text-primary-600 transition-colors",
        title: "新增子分类"
      }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
        class: "h-3.5 w-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1)]))]), _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.$emit('edit', __props.node), ["stop"])),
        class: "rounded p-1 text-slate-400 hover:text-primary-600 transition-colors",
        title: "编辑"
      }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
        class: "h-3.5 w-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
      })], -1)]))]), _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => _ctx.$emit('delete', __props.node), ["stop"])),
        class: "rounded p-1 text-slate-400 hover:text-red-600 transition-colors",
        title: "删除"
      }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
        class: "h-3.5 w-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })], -1)]))])])) : _createCommentVNode("", true)], 6), hasChildren.value && isExpanded.value ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.node.children, child => {
        return _openBlock(), _createBlock(_component_KbCategoryTreeNode, {
          key: child.id,
          node: child,
          depth: __props.depth + 1,
          "selected-id": __props.selectedId,
          "expanded-ids": __props.expandedIds,
          "show-actions": __props.showActions,
          onSelect: _cache[6] || (_cache[6] = id => _ctx.$emit('select', id)),
          onToggle: _cache[7] || (_cache[7] = id => _ctx.$emit('toggle', id)),
          onEdit: _cache[8] || (_cache[8] = n => _ctx.$emit('edit', n)),
          onDelete: _cache[9] || (_cache[9] = n => _ctx.$emit('delete', n)),
          onAddChild: _cache[10] || (_cache[10] = n => _ctx.$emit('add-child', n))
        }, null, 8, ["node", "depth", "selected-id", "expanded-ids", "show-actions"]);
      }), 128)) : _createCommentVNode("", true)]);
    };
  }
};